import React from 'react';

import TenantService from 'App/services/tenant';

const menuInputMail = TenantService.getOperationsEmail();
const how_section_columns = [
  {
    title: 'Wprowadzamy Twoje menu',
    desc: <>
      Skontaktuj się z nami dzwoniąc pod numer <a href="tel:+48577082874" className="nowrap">+48 577 082 874</a> lub wysyłając wiadomość na adres <a href={`mailto:${menuInputMail}`}>{menuInputMail}</a> w celu dostarczenia menu, a my wprowadzimy je i wrócimy z informacją w ciągu 24 godzin.
    </>,
    icon: 'ic-sharp-menu-book'
  },
  {
    title: 'Skonfigurujemy system dla Ciebie',
    desc: 'Otrzymasz dostęp do aplikacji, którą możesz używać na dowolnym urządzeniu z dostępem do Sieci - laptopie, tablecie i nawet komórce.',
    icon: 'fa-solid:user-cog'
  },
  {
    title: 'Zaczynamy!',
    desc: 'Przeprowadzimy kampanię marketingową, aby Twoi klienci dowiedzieli się, jak łatwo mogą składać u Ciebie zamówienia.',
    icon: 'mdi:state-machine'
  }
];

const OnlineOrdersProcess = () => {
  return <div className="row">
    {how_section_columns.map(col => <article className="how-section-item" key={col.title}>
      <span className="iconify" data-inline="false" data-icon={col.icon}></span>
      <h3 className="fr-subtitle">{col.title}</h3>
      <p className="fr-desc">{col.desc}</p>
    </article>)}
  </div>;
};

export default OnlineOrdersProcess;
